import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import { useTranslation } from 'react-i18next'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import {
  Form,
  Input,
  notification,
  Select,
  InputNumber,
  Breadcrumb,
} from 'antd'
import Button from 'components/CustomButtons/Button.js'
import { Link, useHistory } from 'react-router-dom'
import {
  fetchstepConfig,
  addNewStepConfig,
} from 'reduxToolkit/features/stepConfig/StepsConfig'
import { fetchStatesNames } from 'reduxToolkit/features/StateNames/StateNamesSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import ErrorModal from 'views/Components/ErrorModal'
const { TextArea } = Input
const layout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 14,
  },
}
const tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 0,
  },
}

const AddStepConfigPage = () => {
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const { Option } = Select

  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [handledError, setHandledError] = useState('')

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false)
  }
  const onFinish = (values) => {
    console.log(values)
    dispatch(addNewStepConfig(values))
      .unwrap()
      .then((res) => {
        handleClose()
        form.resetFields()
        openNotificationWithIcon('success', `Added successfully`)
      })
      .catch((err) => {
        setHandledError(err)
        handleOpenErrorModal()
      })
  }
  const handleClose = () => {
    history.push(`/citrine/configuration/others/StepConfigPage`)
  }
  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    })
  }
  const statesNames = useSelector((state) => state.stateNames.statesNames)
  console.log(statesNames)
  useEffect(() => {
    dispatch(fetchStatesNames())
  }, [])

  return (
    <div>
      <GridContainer
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <GridItem>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>{t('Configurations')}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/others`}>
                <span> {t('other Configurations')} </span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/others/StepConfigPage`}>
                <span>{t('Step Config Page')}</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span> {t('Add')} </span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <Card>
          <CardBody>
            <GridItem xs={12} sm={12} md={12}>
              <Form
                {...layout}
                form={form}
                name="control-hooks"
                onFinish={onFinish}
              >
                <br />
                <Form.Item
                  label={t('State Name')}
                  name="stateName"
                  rules={[
                    {
                      required: true,
                      message: 'Please select state name.',
                    },
                  ]}
                >
                  <Select
                    style={{ width: '100%' }}
                    dropdownStyle={{ zIndex: 10000 }}
                    placeholder="State Name"
                  >
                    {statesNames?.map((stateName) => (
                      <Option key={stateName.id} value={stateName.id}>
                        {stateName?.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <br />
                <Form.Item
                  name="index"
                  label="Index"
                  placeholder="Index"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter index.',
                    },
                  ]}
                >
                  <InputNumber style={{ width: '50%' }} />
                </Form.Item>
                <Form.Item {...tailLayout}>
                  <Button
                    style={{ marginRight: '20px' }}
                    color="danger"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button type="primary" color="info">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </GridItem>
          </CardBody>
        </Card>
      </GridContainer>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  )
}

export default AddStepConfigPage
